module.exports = __webpack_public_path__ + "img/Al2O3.4dc91ff1.png";